import Collapse from "antd/lib/collapse"
import React from "react"
import styled from "styled-components"
import {Flex} from "../../../components/Flex"
import {Legend} from "../../../components/Legend"
import {BadgeChart} from "./BadgeChart"

const Badge = (props) => {
  const headerRendered = (
    <BadgeDiv>
      <Flex style={{alignItems: "flex-start"}}>
        {props.chart && (
          <BadgeChart
            colors={props.chart.colors}
            labels={props.chart.labels}
            values={props.chart.values}
          />
        )}
        <ContentDiv>
          <ValueDiv>{props.renderValue(props.value)}</ValueDiv>
          <NameDiv>{props.name}</NameDiv>
        </ContentDiv>
      </Flex>
    </BadgeDiv>
  )

  const legendItems = props.chart.colors.map((color, index) => ({
    color,
    label: props.chart.labels[index],
    value: props.renderValue(props.chart.values[index]),
  }))

  return (
    <Collapse bordered={false} expandIconPosition="right">
      <Collapse.Panel header={headerRendered} key="1">
        {props.chart && (
          <LegendOuterDiv>
            <LegendInnerDiv>
              <Legend items={legendItems} />
            </LegendInnerDiv>
          </LegendOuterDiv>
        )}
      </Collapse.Panel>
    </Collapse>
  )
}

const BadgeDiv = styled.div`
  padding: ${(props) => props.theme.gutter}px;
`

const ContentDiv = styled.div`
  padding-right: ${(props) => props.theme.gutter}px;
`

const LegendInnerDiv = styled.div`
  border: 1px solid ${(props) => props.theme.borderColorLight};
  padding: ${(props) => props.theme.gutter}px;
`

const LegendOuterDiv = styled.div`
  padding: ${(props) => props.theme.gutter}px;
  padding-top: 0;
`

const NameDiv = styled.div`
  margin-top: 0.5rem;
`

const ValueDiv = styled.div`
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
  margin-top: 5px;
`

export {Badge}
